import React, { useEffect, useState } from 'react';
import CustomTable from '../../share-components/CustomTable';
import { useAppContext } from '../../share-components/AppContext';
import SearchColumnSelect from '../../share-components/SearchColumnSelect';
import FormTitle from '../../share-components/FormTitle';
import { useNavigate } from 'react-router-dom';
import { SERVER_ERROR_MESSAGE } from '../../constants/commonConstants';
import NoDataFound from '../../share-components/NoDataFound';
import { getOutOfStocksData } from '../../services/InstockAdjustmentService';

const OutOfStocks = () => {
    const { setLoading, setShowApiErrorMessage, setRouteNaviData } = useAppContext();
    const [outOfStockData, setOutOfStockData] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [isFirstLoaded, setIsFirstLoaded] = useState(false);
    const navigate = useNavigate();

    const fetchOutOfStocks = async () => {
        try {
            setLoading(true);
            const response = await getOutOfStocksData();
            const convertedResponse = (response?.outOfStockList || []).map(item => {
                const updatedData = {
                    ...item,
                    colorSize: `${item.color ? '[' + item.color + ']' : ''}${item.size ? ' [' + item.size + ']' : ''}`
                }
                return updatedData;
            })
            setOutOfStockData(convertedResponse);
            setIsFirstLoaded(true);
        } catch (error) {
            const errMsg = error?.response?.data?.errorMessage || SERVER_ERROR_MESSAGE;
            if (error.status !== 401 && error.status !== 403) {
                setShowApiErrorMessage(errMsg);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setRouteNaviData("STOCK >> OUT OF STOCKS")
        fetchOutOfStocks();
    }, []);

    const columns = [
        {
            Header: 'Product Name',
            accessor: 'productName',
            style: {
                maxWidth: "200px"
            }
        },
        {
            Header: 'Color/Size',
            accessor: 'colorSize',
            style: {
                maxWidth: "200px"
            }
        },
        {
            Header: 'OutOfStock',
            accessor: 'outOfStockQuantity',
            style: {
                maxWidth: "200px",
                color: "red",
                fontWeight: "bold"
            }
        },
        {
            Header: 'Brand Name',
            accessor: 'brandName',
            style: {
                maxWidth: "200px"
            }
        },
        {
            Header: 'Category Name',
            accessor: 'categoryName',
            style: {
                maxWidth: "200px"
            }
        },
    ];

    return (
        <div id='outOfStockPage'>
            <FormTitle title={"Out Of Stock Item(s)"} isCenter={true} />
            {isFirstLoaded && <div style={{ overflow: "auto", paddingBottom: "50px"}}>
                <div style={{ minWidth: "max-content", maxWidth: "850px", margin: '0 auto' }}>
                    <div>
                        <div style={{ marginBottom: '10px', marginTop: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'end', flexWrap: 'wrap', gap: '5px' }}>
                            <div style={{ display: 'inline-block' }}>
                                <SearchColumnSelect data={outOfStockData} setData={setFilteredData} columns={columns} />
                            </div>
                        </div>
                        {filteredData?.length > 0 ? 
                        <CustomTable
                            tableId='outOfStockTbl'
                            columns={columns}
                            tblData={filteredData || []}
                            showPagination={true}
                            initialSortBy={[{ id: 'productName', desc: false }]}
                            itemsPerPage={30}
                        /> : <NoDataFound />}
                    </div>
                </div>
            </div>}
        </div>
    );
};

export default OutOfStocks;